import React, { useEffect, useState } from 'react';

import './TimeLine.scss';
import { useInterval } from '../../../../helpers/customHooks';
import { msToTime } from '../../../../helpers/helpers';
import { FUTURE, LIVE, PAST } from '../../../../config/constants';
import Stamp from './Stamp';
import { StampType } from 'components/Viewer/types';

export default ({ height, width, data }:{height:number, width: number, data:any}) => {
  const calc = (d:any) => {
    const data = JSON.parse(JSON.stringify(d));
    if (data.stamps.length > 0) {
      let maxTimeStamp = 0;
      let minTimeStamp = Number.MAX_SAFE_INTEGER;
      data.stamps.forEach((stamp:StampType) => {
        minTimeStamp = Math.min(minTimeStamp, stamp.timeStamp);
        maxTimeStamp = Math.max(maxTimeStamp, stamp.timeStamp);
      });
      let initialRange = 0;
      if (data.status === PAST) { // for past this is the correct range
        initialRange = Math.max(maxTimeStamp - minTimeStamp, 0);
      }

      return [minTimeStamp, initialRange];
    }
    return [0, 0, 0];
  };
  const [current, setCurrent] = useState(0);
  const [minTime, setMinTime] = useState(0);
  const [range, setRange] = useState(0);
  useEffect(() => {
    const [a, b] = calc(data);
    setMinTime(a);
    if (data.status === PAST) { // for past this is the correct range
      setRange(b);
    }
  }, [data]);
  useInterval(() => {
    const now = new Date().getTime();
    setCurrent(now);
  }, data.status === LIVE ? 1000 : null);
  useEffect(() => {
    if (data.status === LIVE) { // for live correct range every second
      const coming = range - (current - minTime);
      const multiplier = Math.ceil((data.slack - coming) / data.plusSlack);
      const rangeCorrected = range + multiplier * data.plusSlack;
      setRange(rangeCorrected);
    }
  }, [current]);

  return (
    <div style={{ height: `${height}px`, width: `${width}` }} className={'time-line-box'}>
      <div
        style={{ height: '100%', width: 'calc(100% - 30px)', position: 'relative', margin: '10px', marginTop: '40px' }}
      >
        <div className="time-line-base-line" />
        {data.status !== FUTURE &&
        <div
          className="time-line-base-line-elapsed"
          style={{ width: data.status === LIVE ? `${((current - minTime) / range) * 100}%` : '100%' }}
        />}
        {data.periods.map((stamp:StampType, index:number) => <Stamp
          minTime={minTime} range={range} stamp={stamp} maxWidth={width - 30}
          key={'period-' + JSON.stringify(stamp) + index}
        />)}
        {data.stamps.map((stamp:StampType, index:number) => <Stamp
          minTime={minTime} range={range} stamp={stamp} maxWidth={width - 30}
          key={'stamp-' + JSON.stringify(stamp) + index}
        />)}
        {data.status === LIVE &&
        <div className="time-line-stamp" style={{ left: `${((current - minTime) / range) * 100}%` }}>
          <div className="time-line-circle" />
          <label className="time-line-label-circle">{msToTime(current - minTime)}</label>
        </div>}
        {data.status === LIVE &&
        <div
          className="time-line-stamp-with-circle future-stamp"
          style={{ left: '100%' }}
        >
        </div>}
      </div>
    </div>
  );
};
